import React, { useState } from "react";
import styles from "./AboutTeam.module.css";
import MyVerticallyCenteredModal from "./MyVerticallyCenteredModal"; // default export now
// Images
import ravi from "./Ravi.jpeg";
import gaurav from "./Gaurav.jpeg";
import mahesh from "./Mahesh.jpeg";
import shailesh from "./shailesh.jpeg";
import omar from "./omar.jpeg";
import parta from "./Prof Patra.png";
import santosh from "./santosh.jpeg";
import jayesh from "./jayesh.jpg";

// Team data
const teamMembers = [
    {
        name: "Ravi Kumar",
        position: "Co-Founder & CEO",
        img: ravi,
        shortDesc: "Leading CirkiTeX, overseeing the overall system development",
        fullDesc:
            "Leading CirkiTeX, overseeing the overall system development, and responsible for the design and development of PLL frequency synthesizers. He earned his PhD from IIT Indore and previously worked with Huawei Singapore and NXP Semiconductors India, where he was involved in PLL design for Wi-Fi, Bluetooth, and automotive applications.",
        linkedIn: "https://linkedin.com/in/ravikumar337",
        category: "leader"
    },
    {
        name: "Gaurav Singh",
        position: "Co-Founder & CTO",
        img: gaurav,
        shortDesc: "Architecting Cirkitex’s SoCs and memory subsystems",
        fullDesc:
            "Architecting Cirkitex’s SoCs and memory subsystems with expertise in RISC-V processors and Compute-In-Memory accelerators. Gaurav completed his D.Sc. (Tech) from Aalto University, Finland, and currently contributes as Postdoctoral Research Fellow at UC Leuven, Belgium.",
        linkedIn: "https://linkedin.com/in/gauravbe",
        category: "leader"
    },
    {
        name: "Mahesh Kumawat",
        position: "Technical Advisor",
        img: mahesh,
        shortDesc: "Specialist in Wireline Communication systems",
        fullDesc:
            "Specialist in Serial Communication system. He earned his PhD from IIT Indore, MP. and is currently with Bennet University, Noida, India, working as an Assistant Professor in Ecletrical Engineering Department.",
        linkedIn: "https://www.linkedin.com/in/dr-mahesh-kumawat-67ab141a/",
        category: "advisor"
    },
    // {
    //     name: "Shailesh Singh Chouhan",
    //     position: "Technical Advisor",
    //     img: shailesh,
    //     shortDesc: "Specialist in Analog Mixed Signal design",
    //     fullDesc:
    //         "Specialist in analog mixed signal design and integration. He earned his D.Sc. (Tech) from Aalto University, Finland, and is currently with Luleå University of Technology, Sweden, working as a Senior Researcher for Cyber-Physical Systems.",
    //     linkedIn: null,
    //     category: "advisor"
    // },
    {
        name: "Omar Numan",
        position: "Technical Advisor",
        img: omar,
        shortDesc: "Specialist in In-Memory Compute (IMC) architecture",
        fullDesc:
            "Specialists in In-Memory Compute (IMC) architecture and calibration circuits. Omar is pursuing his D.Sc. (Tech) from Aalto University, Finland, and brings hands-on IMC expertise to Cirkitex.",
        linkedIn: "https://www.linkedin.com/in/omarnn95/",
        category: "advisor"
    },
    {
        name: "Prof. Priyadarsan Patra",
        position: "Academic Advisor",
        img: parta,
        shortDesc: "Advices on our academic initiatives and works to expand our presence.",
        fullDesc:
            "Prof. Priyadarsan Patra is Vice Chancellor of NIST, Berhampur, Odisha. Prof. Patra holds a Ph.D. degree in  Computer Sciences from the University of Texas at Austin, an M.S. from the University of Massachusetts at Amherst, and a B.Engg from the Indian Institute of Science, Bangalore. He has served as a Chief Architect and Principal Scientist at the R&D divisions of Intel Corp (USA). He created and led world-class research and development for Servers, Systems-on-Chip, processors, and smart devices on in-memory computing, AI hardware accelerators, implantable medical devices, secure circuits, and silicon photonics. He has led several innovative chip design projects, advancing energy-efficient and intelligent electronic systems. He has edited multiple technical proceedings, has authored 80+ scholarly publications, 4 scientific books, 13 USA and international patents, and other influential articles.",
        linkedIn: "https://www.linkedin.com/in/darshanpatra/",
        category: "advisor"
    },
    {
        name: "Prof. Santosh Kumar Vishvakarma",
        position: "Academic Advisor",
        img: santosh,
        shortDesc: "Advices on our academic initiatives and works to expand our presence.",
        fullDesc:
            "Prof. Santosh Kumar Vishvakarma is a Professor of Electrical Engineering at IIT Indore and heads the NSDCS Lab. His research focuses on in-memory computing, AI hardware accelerators, implantable medical devices, secure circuits, and silicon photonics. He has led several innovative chip design projects, advancing energy-efficient and intelligent electronic systems..",
        linkedIn: "https://www.linkedin.com/in/dr-santosh-kumar-vishvakarma/?originalSubdomain=in",
        category: "advisor"
    },
    {
        name: "Jayesh Nayak",
        position: "Finance and Product Advisor",
        img: jayesh,
        shortDesc: "Product Management and Finance",
        fullDesc:
            "Expert in company finance and product manegement. He earned his MBA from IIM Kozhikode and is currently with PayPal working as Senior Product Manager.",
        linkedIn: "https://www.linkedin.com/in/jayesh-nayak/",
        category: "advisor"
    }



];

// Card Component
const TeamCard = ({ member, onViewMore }) => (
    <div className={styles.item}>
        <img src={member.img} alt={member.name} />
        <h4 style={{ textAlign: "center" }}>{member.name}</h4>
        <h6>{member.position}</h6>
        <p>{member.shortDesc}</p>
        <a className={styles.viewMoreBtn} onClick={() => onViewMore(member)}>
            View More
        </a>
    </div>
);

export const AboutTeam = () => {
    const [modalShow, setModalShow] = useState(false);
    const [selectedMember, setSelectedMember] = useState(null);

    const handleViewMore = (member) => {
        setSelectedMember(member);
        setModalShow(true);
    };

    return (
        <div className={styles.container}>
            {/* Leaders */}
            <div className={styles.leader}>
                <h2 style={{ color: "white" }}>Our Leaders</h2>
                <div className={styles.card}>
                    {teamMembers
                        .filter((m) => m.category === "leader")
                        .map((member) => (
                            <TeamCard key={member.name} member={member} onViewMore={handleViewMore} />
                        ))}
                </div>
            </div>

            {/* Advisors */}
            <div className={styles.leader} >
                <h2 style={{ color: "white" }}>Our Advisors</h2>
                <div className={styles.card}>
                    {teamMembers
                        .filter((m) => m.category === "advisor")
                        .map((member) => (
                            <TeamCard key={member.name} member={member} onViewMore={handleViewMore} />
                        ))}
                </div>
            </div>

            {/* Modal */}
            {selectedMember && (
                <MyVerticallyCenteredModal
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    title={selectedMember.name}
                    position={selectedMember.position}
                    description={selectedMember.fullDesc}
                    linkedIn={selectedMember.linkedIn}
                    img={selectedMember.img}
                />
            )}
        </div>
    );
};
